import { ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface FormRowProps {
  children: ReactNode
  columns?: number // number of columns for the grid
  className?: string
  gap?: string // Tailwind gap class, e.g. 'gap-4'
}

export function FormRow({ children, columns = 2, className, gap = 'gap-5' }: FormRowProps) {
  const rows = 'sm:grid-cols-' + columns
  return <div className={cn('grid grid-cols-1', rows, gap, className)}>{children}</div>
}
